// extracted by mini-css-extract-plugin
export var downArrow = "_9r-0";
export var infoTooltipIcon = "_9r-3";
export var label = "_9r-1";
export var optionCard = "_9r-4";
export var upArrow = "_9r-2";